import type { IFuseOptions } from "fuse.js";

import type { Artist } from "@/types/types";

// Configuration for artist search with weighted keys
export const artistFuseConfig: IFuseOptions<Artist> = {
  includeScore: false,
  isCaseSensitive: false,
  keys: [
    { name: "name", weight: 2 },
    { name: "filters.tags.primary", weight: 1 },
    { name: "filters.tags.secondary", weight: 0.5 },
  ],
  threshold: 0.3,
};
